import { Breakpoint } from '../../../types'

export const buildClass =
  <TSingle extends string | number>(prefix: string) =>
  (value: TSingle | undefined, breakpoint?: Breakpoint) => {
    if (value === undefined) return ''
    return joinPieces([prefix, breakpoint === 'xs' ? '' : breakpoint, value])
  }

const joinPieces = (pieces: Array<string | number | undefined>) =>
  pieces.filter((v) => v !== undefined && v !== '').join('-')
